"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DeviceReadiness = require("./DeviceReadiness");
Object.keys(_DeviceReadiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceReadiness[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DeviceReadiness[key];
    }
  });
});